import { instance, errorService } from '@/services/api'
import { masterAPIs } from '@/services/authConstantsV1'
import { socketEvents } from '@/services/config'
import moment from 'moment'

export default {
  data: function() {
    return {
      notificationList: [],
      count: 0,
      progress: 0,
      intervalId: null,
      status: 'active',
      duration: 0,
      moment,
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      socketEvents: socketEvents,
    }
  },
  mounted() {
    this.$root.$off('socketMessage')
    this.$root.$on('socketMessage', this.messageReceived)
    const list = JSON.parse(localStorage.getItem('notifications'))
    if (list && list.length > 0) {
      this.notificationList = list
    }
  },
  beforeDestroy() {
    this.$root.$off('socketMessage')
  },
  methods: {
    menuClicked(event) {
      if (
        this.notificationList[event.key].EventType ===
          socketEvents.fileDownloaded ||
        this.notificationList[event.key].EventType === socketEvents.fileExported
      ) {
        this.download(this.notificationList[event.key])
      }
    },

    makeCountZero() {
      this.count = 0
      const notificationsData = [...this.notificationList]
      if (notificationsData.length > 0) {
        notificationsData.map(data => {
          data['actualTime'] = moment(data['notificationTime']).fromNow()
          return data
        })
        this.notificationsData = notificationsData
      }
    },

    download(record) {
      const that = this
      this.$notification.destroy()
      this.$notification.info({
        message: 'Downloading File',
        description: function(createElement) {
          return createElement('div', [
            createElement(
              'div',
              'Please wait while your file is downloading...',
            ),
            createElement('a-progress', {
              props: {
                percent: that.progress,
              },
              attrs: {
                status: that.status,
              },
            }),
          ])
        },
        duration: that.duration,
      })
      this.downloadProgress()
      instance
        .post(masterAPIs.download, record.Result, {
          responseType: 'arraybuffer',
        })
        .then(response => {
          if (response.status === 200) {
            const blob = new Blob([response.data])
            const fileURL = URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            const fileExtension = record.extension
              ? `.${record.extension}`
              : '.xlsx'
            fileLink.href = fileURL
            fileLink.setAttribute('download', record.name + fileExtension)
            document.body.appendChild(fileLink)
            fileLink.click()
            that.status = 'success'
            that.progress = 100
            setTimeout(function() {
              that.$notification.destroy()
            }, 1000)
          }
        })
        .catch(err => {
          that.status = 'exception'
          that.progress = 100
          setTimeout(function() {
            that.$notification.destroy()
          }, 1000)
          errorService(err)
        })
    },

    downloadProgress() {
      const that = this
      this.intervalId = setInterval(function() {
        if (that.progress < 50) {
          that.progress = that.progress + 1
        } else if (that.progress >= 50 && that.progress < 75) {
          that.progress = that.progress + 0.5
        } else if (that.progress >= 75 && that.progress < 90) {
          that.progress = that.progress + 0.25
        } else if (that.progress >= 90 && that.progress < 95) {
          that.progress = that.progress + 0.1
        } else if (that.progress >= 95) {
          that.progress = that.progress + 0.01
        } else {
          clearInterval(that.intervalId)
        }
      }, 200)
    },

    messageReceived(message) {
      const list = JSON.parse(localStorage.getItem('notifications'))
      if (list && list.length > 0) {
        this.notificationList = list
      }
      localStorage.removeItem('notifications')
      const notification = message
      notification.notificationTime = moment().format()
      this.notificationList.unshift(notification)
      this.count++
      localStorage.setItem(
        'notifications',
        JSON.stringify(this.notificationList),
      )
    },

    capitalize(str) {
      return str
        ? str
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.substring(1))
          .join(' ')
        : str
    },
  },
}
